import {ATLAS_TMM_DB, REALTIME_DB} from '../config/firebase';
import {get, ref} from 'firebase/database';

export interface IFlightPax {
  id: string;
  affected_con_pax_number: number;
  con_pax_number: number;
  pax: number;
}

export const flightPax = async (airline: string) => {
  const snapshot = await get(
    ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/flight_pax`)
  );
  if (snapshot.exists()) {
    return snapshot.val();
  }
  return {};
};

export const stationOfAirline = async (airline: string) => {
  const snapshot = await get(
    ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/stations`)
  );
  if (snapshot.exists()) {
    return snapshot.val() as string[];
  }
  return [];
};

export const getAllAircraftBasicData = async () => {
  const snapshot = await get(ref(REALTIME_DB, '/aircraft_data/fleet'));
  const data = snapshot.val();
  const aircraftGroup: any = {};
  const keys = Object.keys(data);
  keys.forEach((key: string) => {
    const temp: string[] = [];
    Object.keys(data[key] || {}).forEach((item: string) => {
      if (!data?.[key]?.[item]) return;
      temp.push(item);
    });
    aircraftGroup[key] = temp;
  });
  window.aircraftGroup = aircraftGroup;
};

export const weatherMapping = {
  FZ: 'Freezing',
  SH: 'Showers',
  RA: 'Rain',
  TS: 'Thunderstorms',
  HZ: 'Haze',
  FU: 'Smoke',
  FG: 'Fog',
  BR: 'Mist',
  SN: 'Snow',
  DZ: 'Drizzle',
  IC: 'Icing',
  DU: 'Dust',
  VA: 'Volcanic Ash'
};
